import { cn } from "@/lib/utils";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export const ChartCard = ({ title, description, action, children, className, contentClassName }) => {
    return (
        <Card className={cn("border-border/70 bg-card shadow-card", className)}>
            {(title || action) && (
                <CardHeader className="flex flex-row items-start justify-between gap-4 space-y-0 pb-2">
                    <div className="space-y-1">
                        {title && (
                            <CardTitle className="text-base font-semibold text-foreground">
                                {title}
                            </CardTitle>
                        )}
                        {description && (
                            <CardDescription className="text-sm text-muted-foreground">
                                {description}
                            </CardDescription>
                        )}
                    </div>
                    {action}
                </CardHeader>
            )}
            <CardContent className={cn("pt-2", contentClassName)}>{children}</CardContent>
        </Card>
    );
};
